import React, { useEffect, useState } from 'react'
import DataLoader from '../../../Utils/DataLoader';
import { apiData } from '../../../actions';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function EscapeRoom() {


    const place = useSelector((state) => state.place);
    const localSelectedCity = localStorage.getItem("selectedCity");
    const formattedCity =
        place?.replace(/\b\w/g, (x) => x.toUpperCase()) || "";

    const [familyDeal, setFamilyDeal] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    const Family_Top_Attractions = async () => {
        const payload = {
            city: place,
        };

        setPageLoading(true);

        try {
            const apiRes = await apiData.getEscapeRoom(payload);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setFamilyDeal(apiRes?.data?.escape?.businesses);
            } else {
                setFamilyDeal([]);
            }
        } catch (error) {
            console.error("Yelp API Error:", error);
            setFamilyDeal([]);
        } finally {
            setPageLoading(false);
        }
    };

    console.log("familyDealfamilyDeal",familyDeal)

    useEffect(() => {
        Family_Top_Attractions();
    }, [place]);

    if (pageLoading) return <DataLoader />;

    return (
        <section className="section-equal-padding owl-nav-left bg-white">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="section-top-heading mb-3 mb-md-5 "
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <h2 className="mb-2 text-black">{localSelectedCity && localSelectedCity !== 'undefined' ? `Escape Room in ${formattedCity}` : 'Escape Room'}</h2>
                            <p>
                               Unleash your inner detective in our thrilling escape room! Solve puzzles, decode clues, and unlock secrets in a race against time. Can you escape?
                            </p>
                        </div>
                    </div>
                </div>
                <div className="">

                    {familyDeal && familyDeal.length > 0 ?
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                992: { slidesPerView: 3 },
                                1400: { slidesPerView: 4 },
                            }}
                            className="excitement-swiper pb-70"
                        >
                            {familyDeal.map((ele, index) => (
                                <SwiperSlide className="" key={ele?.id || index} >
                                    <div className="resorts-box p-3 bg-white w-100">
                                        <figure>
                                            <img loading="lazy" src={ele?.image_url} alt="Family" />
                                        </figure>
                                        <div className="resorts-content-box">
                                            <div className="resort-description p-0 m-0 border-0">
                                                <h3>{ele?.name}</h3>
                                            </div>
                                            <div className="d-flex justify-content-between location-box">
                                                <span className="rating-star location-icon"><i className="fa-solid fa-location-dot"></i>
                                                    {ele?.location?.city}
                                                </span>
                                                <span className="rating-star"><i className="fa-solid fa-star"></i>
                                                    {ele?.rating}
                                                </span>
                                            </div>
                                            <div className="book-trip-btn">
                                                <a className='text-center w-100' href={ele?.url} target="_blank" rel="noreferrer">{ele?.categories[0]?.title}</a>
                                            </div>
                                        </div>
                                    </div>

                                </SwiperSlide>
                            ))}
                        </Swiper> : `Oops! No Data Available ${`For ${formattedCity}`}`
                    }
                </div>
            </div>
        </section>
    )
}
